import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TODO_COLOR = token('color.border', colors.N40A);
export const IN_PROGRESS_COLOR = token('color.border.information', colors.B200);
export const DONE_COLOR = token('color.border.success', colors.G300);
export const WARNING_COLOR = token('color.background.warning.bold.hovered', colors.Y300);
